import { useSyncExternalStore } from "react";

export default function createEvent<DataType>(
  get: () => DataType
): [() => DataType, () => void] {
  let listeners: (() => void)[] = [];

  const addListener = (listener: () => void) => (
    listeners.push(listener),
    () => {
      listeners = listeners.filter((l) => l != listener);
    }
  );

  const useListen = (): DataType => useSyncExternalStore(addListener, get);

  const dispatch = () => listeners.forEach((l) => l());

  return [useListen, dispatch];
}
